/*
  Free shipping bar (snippets/free-shipping-bar.liquid).

  Liquid draws each bar for the cart as it was when the page loaded. This keeps every bar on
  the page in step afterwards: when something is added, removed or changed in the cart drawer
  or cart page, and when the shopper comes back with the browser's back button.

  Money is in pence (integers) throughout, as in /cart.js. The amount counts the cart total
  after discounts, ignoring items that don't need shipping (gift cards), matching the Liquid.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-fsb]';
  var refreshing = false;
  var refreshAgain = false;

  function formatMoney(cents) {
    var format = window.theme && theme.settings && theme.settings.moneyFormat;
    if (window.theme && theme.Currency && format) {
      return theme.Currency.formatMoney(cents, format);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  // Returns { state, remaining, pct } for a /cart.js style cart.
  function compute(cart, threshold) {
    var unshipped = 0;
    (cart.items || []).forEach(function (item) {
      if (item.requires_shipping === false) unshipped += item.final_line_price || 0;
    });
    var qualifying = Math.max(0, (cart.total_price || 0) - unshipped);
    var remaining = threshold - qualifying;
    var state = !cart.item_count ? 'empty' : remaining <= 0 ? 'qualified' : 'progress';
    var pct = Math.min(100, Math.round((qualifying * 100) / threshold));
    // Never show a full bar until the bag has actually qualified (rounding would otherwise do it at 39.99).
    if (state !== 'qualified') pct = Math.min(99, pct);
    return { state: state, remaining: remaining, pct: pct };
  }

  function fill(template, values) {
    return template
      .replace(/\{amount\}/g, function () { return values.amount; })
      .replace(/\{threshold\}/g, function () { return values.threshold; });
  }

  function render(el, cart) {
    var threshold = parseInt(el.dataset.threshold, 10);
    if (!threshold || threshold < 1) return;

    var result = compute(cart, threshold);
    var template = {
      empty: el.dataset.msgEmpty,
      progress: el.dataset.msgProgress,
      qualified: el.dataset.msgQualified
    }[result.state];

    var message = fill(template || '', {
      amount: formatMoney(Math.max(0, result.remaining)),
      threshold: formatMoney(threshold)
    });
    if (el.dataset.prefix) message = el.dataset.prefix + ' ' + message;

    var text = el.querySelector('[data-fsb-text]');
    if (text && text.textContent !== message) text.textContent = message;

    var bar = el.querySelector('[data-fsb-fill]');
    if (bar) bar.style.width = result.pct + '%';

    el.classList.remove('is-empty', 'is-progress', 'is-qualified');
    el.classList.add('is-' + result.state);
  }

  function renderAll(cart) {
    if (!cart) return;
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      render(el, cart);
    });
  }

  // Fetch the cart and update every bar. Calls that arrive while one is running are merged
  // into a single follow-up so a burst of cart events makes at most two requests.
  function refresh() {
    if (!document.querySelector(SELECTOR)) return Promise.resolve();
    if (refreshing) {
      refreshAgain = true;
      return Promise.resolve();
    }
    refreshing = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart ' + response.status);
        return response.json();
      })
      .then(renderAll)
      .catch(function () {
        /* leave the bars as they are */
      })
      .then(function () {
        refreshing = false;
        if (refreshAgain) {
          refreshAgain = false;
          return refresh();
        }
      });
  }

  // cart:updated carries the new cart (quantity changes and removals), so no extra request.
  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      renderAll(cart);
    } else {
      refresh();
    }
  });

  // Adds (from a collection grid, the product page, quick shop) announce themselves without the cart.
  document.addEventListener('ajaxProduct:added', refresh);

  // Back/forward navigation can restore a page from memory with an out-of-date cart.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  window.lbpFreeShippingBar = { refresh: refresh, render: renderAll, compute: compute };
})();
